<tax-page-header titleText="organization.title"></tax-page-header>

<main class="ui-kit-white-card">
  <div class="white-card">
    <div class="ui-kit-rows-layout">
      <div class="block_title" translate>registration.admin</div>
      <div class="columns-field_2 login-field">
        <span translate>user.form.login</span>
        <span>{{ organization?.rootLogin }}</span>
      </div>
      <tax-password
        [labelText]="'user.form.password'"
        [id]="'password'"
        [formControl]="password"
        [layoutColumns]="2"
        [inputStyles]="'max-width: 33%'"
        [autofocus]="true"
        [tabindex]="1"
      ></tax-password>
      <tax-password
        [labelText]="'user.form.password.confirmation'"
        [id]="'password-confirmation'"
        [formControl]="passwordConfirmation"
        [layoutColumns]="2"
        [inputStyles]="'max-width: 33%'"
        [tabindex]="1"
      ></tax-password>
    </div>

    <hr class="greyline" />

    <!--TODO: fix $any-->
    <tax-edit-legal
      *ngIf="organization?.type === organisationType.Legal"
      [organization]="$any(organization)"
      [isRegistration]="true"
      [isPasswordValid]="password.valid && passwordConfirmation.value && passwordConfirmation.valid"
      (goBack)="goBack()"
      (submitForm)="submitForm($any($event))"
    >
    </tax-edit-legal>
    <!--TODO: fix $any-->
    <tax-edit-individual
      *ngIf="organization?.type === organisationType.Individual"
      [organization]="$any(organization)"
      [isRegistration]="true"
      [isPasswordValid]="password.valid && passwordConfirmation.value && passwordConfirmation.valid"
      (goBack)="goBack()"
      (submitForm)="submitForm($any($event))"
    >
    </tax-edit-individual>
  </div>
</main>

<tax-success-window
  *ngIf="showSuccessWindow && organization"
  [action]="'success-registration'"
  (closed)="loginToCabinet(organization)"
></tax-success-window>
